export default "__VITE_ASSET__BxWnunGf__"